// File: TrainingPrograms.js
import React, { useState } from "react";
import { Container, Row, Col, Nav, Tab, Button, Modal } from "react-bootstrap";
import {
  FaUniversity,
  FaBalanceScale,
  FaGavel,
  FaLaptopCode,
  FaCogs,
  FaChalkboardTeacher,
  FaShieldAlt,
  FaLeaf,
} from "react-icons/fa";

const SyllabusPage = () => {
  const [activeKey, setActiveKey] = useState("central");
  const [showModal, setShowModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const openModal = (course) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedCourse(null);
  };

  const syllabusData = {
    central: {
      title: "Central Government Exams",
      description:
        "Nationwide competitive exams conducted by UPSC, SSC, IBPS, and others for prestigious government roles.",
      sectors: [
        {
          name: "Civil Services & Administrative Sector",
          icon: <FaUniversity />,
          syllabus: [
            "General Studies (Prelims + Mains)",
            "Essay Writing & Ethics",
            "Optional Subject Coaching (History, Geography, Sociology, Public Administration, etc.)",
            "Interview & Personality Test Guidance",
            "Mock Tests, Current Affairs & Answer Writing Practice",
          ],
        },
        {
          name: "Technical & Engineering Sector",
          icon: <FaCogs />,
          syllabus: [
            "Core Engineering Concepts",
            "GATE-level Quantitative Practice",
            "Project Management & Robotics",
            "AI-ML Integration",
            "Renewable Energy Systems",
          ],
        },
        {
          name: "Research & Academic Sector",
          icon: <FaChalkboardTeacher />,
          syllabus: [
            "Research Methodology",
            "Scientific Paper Writing",
            "Subject Specialization",
            "Proposal Writing",
            "Interview & Fellowship Guidance",
          ],
        },
        {
          name: "Finance & Banking Sector",
          icon: <FaBalanceScale />,
          syllabus: [
            "Quantitative Aptitude",
            "Reasoning & English",
            "Banking Awareness",
            "Current Affairs",
            "Financial Systems & Economic Policy",
          ],
        },
        {
          name: "Legal & Judicial Sector",
          icon: <FaGavel />,
          syllabus: [
            "Constitution of India",
            "IPC, CrPC, CPC",
            "Contract Law & Legal Drafting",
            "Legal GK",
            "Moots & Interview Prep",
          ],
        },
        {
          name: "Defence & Security Sector",
          icon: <FaShieldAlt />,
          syllabus: [
            "Aptitude & General Knowledge",
            "Military Science",
            "SSB Interview Preparation",
            "Fitness Training",
            "Psychological Tests",
          ],
        },
      ],
    },
    state: {
      title: "State Government Exams",
      description:
        "Each state conducts its own PSC exams and specialized recruitments for administrative and technical posts.",
      sectors: [
        {
          name: "State Administrative & Allied Services",
          icon: <FaUniversity />,
          syllabus: [
            "State-specific GK, History & Polity",
            "State Geography & Schemes",
            "Current Affairs",
            "Prelims + Mains + Interview Preparation",
          ],
        },
        {
          name: "State Technical & Engineering",
          icon: <FaCogs />,
          syllabus: [
            "Core Subject (Civil, Mechanical, Electrical, etc.)",
            "State Policies & Infrastructure Projects",
            "Environment & Smart City Initiatives",
            "Project Management Skills",
          ],
        },
        {
          name: "Education & Research Sector",
          icon: <FaChalkboardTeacher />,
          syllabus: [
            "Pedagogy & Educational Psychology",
            "Teaching Aptitude",
            "Subject-specific Syllabus",
            "Teaching Methods & Evaluation",
          ],
        },
        {
          name: "Police, Defence & Safety",
          icon: <FaShieldAlt />,
          syllabus: [
            "Reasoning & GK",
            "Law Basics",
            "Physical Training",
            "Medical Tests & Interview",
          ],
        },
        {
          name: "Agriculture & Environment Sector",
          icon: <FaLeaf />,
          syllabus: [
            "Soil Science & Crop Production",
            "Irrigation Techniques",
            "Forestry & Environmental Studies",
            "Climate & Biodiversity",
          ],
        },
      ],
    },
    technology: {
      title: "Emerging Technology Sectors",
      description:
        "Advanced training for global tech transformation — integrating AI, Quantum, Energy, SpaceTech, Blockchain, and Agritech.",
      sectors: [
        {
          name: "Artificial Intelligence & Machine Learning",
          icon: <FaLaptopCode />,
          syllabus: [
            "AI Fundamentals & Neural Networks",
            "Machine Learning Algorithms",
            "Deep Learning Frameworks",
            "LLMs & NLP Applications",
            "AI in Governance & Defence",
          ],
        },
        {
          name: "Quantum Computing & Research",
          icon: <FaCogs />,
          syllabus: [
            "Quantum Mechanics Basics",
            "Qubits, Gates, and Circuits",
            "Quantum Algorithms",
            "Quantum Cryptography",
            "Applications in Space & Energy",
          ],
        },
        {
          name: "SpaceTech & Aerospace Research",
          icon: <FaUniversity />,
          syllabus: [
            "Orbital Mechanics & Satellite Communication",
            "Space Propulsion & Control",
            "Remote Sensing & Planetary Science",
            "Astrophysics Fundamentals",
            "AI for Space Applications",
          ],
        },
        {
          name: "Blockchain & Cybersecurity",
          icon: <FaShieldAlt />,
          syllabus: [
            "Blockchain Architecture",
            "Smart Contracts & Decentralization",
            "Cryptography & Network Security",
            "Digital Governance Applications",
            "Cyber Threat Analysis",
          ],
        },
        {
          name: "Energy & Sustainability",
          icon: <FaLeaf />,
          syllabus: [
            "Renewable Energy Systems",
            "Sustainable Engineering Design",
            "AI for Smart Grids",
            "Energy Auditing & Management",
            "Green Tech Innovations",
          ],
        },
      ],
    },
  };

  return (
    <Container fluid className="py-5 bg-light my-5 ">
      <h1 className="text-center mb-4 fw-bold text-primary">
        Comprehensive Syllabus for Training Modules...
      </h1>
      <Row>
        {/* Sidebar */}
        <Col md={3} className="mb-4 py-3 border-0 shadow">
          <Nav
            variant="pills"
            className="flex-column mb-3 fw-bold"
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
          >   <h2 className=" text-center fw-bold" > Sectors/Industry ... </h2> <hr/>
            <Nav.Item>
              <Nav.Link  eventKey="central">🏛 Central Government</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="state">🏢 State Government</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="technology">💻 Technology Sectors</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>

        {/* Main Content */}
       <Col md={9}>
  <Tab.Container activeKey={activeKey}>
    <Tab.Content>
      {Object.entries(syllabusData).map(([key, data]) => (
        <Tab.Pane eventKey={key} key={key}>
          <h4 className="fw-bold mb-2">{data.title}</h4>
          <p>{data.description}</p>
          <hr />

          {/* Two-column layout */}
          <Row>
            {data.sectors.map((sector, index) => (
              <Col md={6} key={index} className="mb-4">
                <div className="p-3 bg-white rounded shadow-sm h-100">
                  <h5 className="fw-bold text-dark mb-2">
                    {sector.icon} {sector.name}
                  </h5>
                  <ul>
                    {sector.syllabus.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                  <div className="mt-3">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => openModal(sector)}
                    >
                      More Info
                    </Button>{" "}
                    <Button
                      variant="success"
                      size="sm"
                      href="/enroll"
                      className="ms-2"
                    >
                      Enroll Now
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Tab.Pane>
      ))}
    </Tab.Content>
  </Tab.Container>
</Col>

      </Row>

      {/* Modal */}
      <Modal show={showModal} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedCourse?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Syllabus Overview:</h6>
          <ul>
            {selectedCourse?.syllabus.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p>
            For comprehensive training and real-world mentoring, join our
            specialized programs conducted by expert faculty and officers.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={closeModal}>
            Close
          </Button>
          <Button variant="primary" href="/enroll">
            Enroll Now
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default SyllabusPage;
